import $ from "jquery";
import CONFIG from "@bd-core/config";
import { getTotalRoomCompleted } from "@bd-stores/game-progress";

export default class Wallet {
    constructor() {
        this.elms = {
            wallet: ".appWallet",
            current: ".appWallet__current",
            total: ".appWallet__total",
        };
    }

    init() {
        // Don't run this on static page
        if (!CONFIG.game.rooms || CONFIG.game.rooms.length === 0) return false;
        const self = this;
        $(document).on("bd__roomDataChanged", () => self.render());
    }

    render() {
        if ($(this.elms.wallet).length < 1) return;
        const totalRoomCompleted = getTotalRoomCompleted() + 1;
        const totalRooms = CONFIG.game.rooms.filter(room => room.type !== "main-room" && room.type !== "ladder-room").length + 1;
        const isCompleted = totalRoomCompleted === totalRooms;
        $(this.elms.current).text(totalRoomCompleted);
        $(this.elms.total).text(totalRooms);
        $(this.elms.wallet).toggleClass("is-completed", isCompleted);
    }

    getWalletStatus() {
        const totalRoomCompleted = getTotalRoomCompleted() + 1;
        const totalRooms = CONFIG.game.rooms.filter(room => room.type !== "main-room" && room.type !== "ladder-room").length + 1;
        const isCompleted = totalRoomCompleted === totalRooms;
        return isCompleted;
    }
}
